import { Link } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';
import { Menu, Button, Alert, Anchor } from '@mantine/core';
import {
  IconUser,
  IconLogout,
  IconHistory,
  IconAlertCircle,
  IconBuildingStore,
  IconListDetails,
  IconDashboard,
} from '@tabler/icons-react';
import styles from './Navigation.module.css';
import { env } from '../../utils/env';
import logo from '../../assets/logo/logo50x50.png';
import { useMediaQuery } from '@mantine/hooks';
import { CommonImage } from '../common/image/CommonImage';

export const Navigation = () => {
  const { user, isAdmin } = useAuth();
  const isMobile = useMediaQuery('(max-width: 768px)');

  return (
    <>
      <nav className={styles.nav}>
        <div className={styles.brand}>
          <Link to="/" className={styles.brandLink}>
            <CommonImage src={logo} alt={env.APP_NAME} size={40} />
          </Link>
        </div>

        {/* Public Navigation Links */}
        <div className={styles.mainNav}>
          <Anchor component={Link} to="/hotlistings" mx="sm">
            Listings
          </Anchor>

          {env.STORE_PAGE_ENABLED && (
            <Anchor component={Link} to="/stores">
              Stores
            </Anchor>
          )}
        </div>

        <div className={styles.actions}>
          {user ? (
            <Menu position="bottom-end" withArrow>
              <Menu.Target>
                <Button
                  variant="subtle"
                  size={isMobile ? 'xs' : 'md'}
                  className={styles.userButton}
                >
                  <IconUser size={20} className={styles.userIcon} />

                  {user.username}
                </Button>
              </Menu.Target>

              <Menu.Dropdown>
                <Menu.Item
                  component={Link}
                  to="/account"
                  leftSection={<IconUser size={16} />}
                >
                  Account
                </Menu.Item>
                <Menu.Item
                  component={Link}
                  to="/account/history"
                  leftSection={<IconHistory size={16} />}
                >
                  History
                </Menu.Item>
                {user.store && (
                  <>
                    <Menu.Divider />
                    <Menu.Item
                      component={Link}
                      to={`/store/${user.store.id}/back-office`}
                      leftSection={<IconBuildingStore size={16} />}
                    >
                      Store Admin
                    </Menu.Item>
                    <Menu.Item
                      component={Link}
                      to={`/store/${user.store.name}/`}
                      leftSection={<IconListDetails size={16} />}
                    >
                      Store Public
                    </Menu.Item>
                    <Menu.Divider />
                  </>
                )}
                {isAdmin && !user.store && <Menu.Divider />}
                {isAdmin && (
                  <>
                    <Menu.Item
                      c="blue"
                      component={Link}
                      to="/siteadmin/stores"
                      leftSection={<IconDashboard size={16} />}
                    >
                      Manage Stores
                    </Menu.Item>
                    <Menu.Item
                      c="blue"
                      component={Link}
                      to="/siteadmin/shipping"
                      leftSection={<IconDashboard size={16} />}
                    >
                      Manage Shipping
                    </Menu.Item>
                    <Menu.Divider />
                  </>
                )}
                <Menu.Item
                  component={Link}
                  to="/auth/logout"
                  leftSection={<IconLogout size={16} />}
                  color="danger"
                >
                  Logout
                </Menu.Item>
              </Menu.Dropdown>
            </Menu>
          ) : (
            <div className={styles.authButtons}>
              <Button
                component={Link}
                to="/auth/login"
                color="accent"
                variant="light"
                size={isMobile ? 'xs' : 'md'}
              >
                Sign In
              </Button>
              <Button
                size={isMobile ? 'xs' : 'md'}
                component={Link}
                to="/auth/register"
                color="brand"
              >
                Sign Up
              </Button>
            </div>
          )}
        </div>
      </nav>
      {user && !user.isEmailVerified && (
        <Alert
          icon={<IconAlertCircle size={16} />}
          title="Email Verification Required"
          color="yellow"
          variant="light"
        >
          Please verify your email, most features are disabled until you confirm
          your email address.
        </Alert>
      )}
    </>
  );
};
